import IFDI from "../../assets/images/IFDI_Summerbuy.jpeg"
import ETE_PRODUCTS_VIDEO from "../../assets/images/ETE_PRODUCTS_VIDEO.png"
import JLP from "../../assets/images/JLP.jpeg"
import EFES26 from "../../assets/images/EFES26.png"
import CATALYST from "../../assets/images/CATALYST.jpeg"

// Add each news item with its publication date (YYYY-MM-DD).
// IFDI uses the event's completion date; existing dates use LinkedIn timestamps.
export const NEWS_ITEMS = [
  {
    id: "ifdi-accelerator-2026",
    publishedAt: "2026-09-24",
    image: IFDI,
    descriptionKey: "ifdi",
    url: "https://lnkd.in/p/dpzHnfiJ",
  },
  {
    id: "ete-products-video-2026",
    publishedAt: "2026-06-16",
    image: ETE_PRODUCTS_VIDEO,
    descriptionKey: "eteProductsVideo",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7472587959050051584",
  },
  {
    id: "jlp-2026",
    publishedAt: "2026-07-03",
    image: JLP,
    descriptionKey: "jlp",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7478791458788143104",
  },
  {
    id: "efes-2026",
    publishedAt: "2026-04-16",
    image: EFES26,
    descriptionKey: "efes26",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7450443585310613504/",
  },
  {
    id: "catalyst-2026",
    publishedAt: "2026-04-14",
    image: CATALYST,
    descriptionKey: "catalyst",
    url:
      "https://www.linkedin.com/feed/update/urn:li:activity:7449737220946731008",
  },
]
